export const ACCOUNT_ENTREMAX = "ENTREMAX";
export const ACCOUNT_APE_SURVIVAL = "APE_SURVIVAL";
export const ACCOUNT_TACTICALBOX = "TACTICALBOX";
export const ACCOUNT_PATRIOT_ADDICT = "PATRIOT_ADDICT";
